import React from "react";
import { validateRegistrationNumber, validateMilage, } from "../utils/validation";
import StoreAction from "../constants/store-action";
import Spinner from "../components/spinner";
import { handleEnterPress } from "../utils/events";
import UserEvent from "../constants/user-event";
export default (props) => {
    const handleInputChange = (e) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "tradeInCar",
            name: e.target.name,
            value: e.target.value,
        });
    };
    const handleBlur = (e) => {
        props.dispatchStoreAction(StoreAction.INTERACT_UPDATE_SPECIFIC, {
            type: "tradeInCar",
            name: e.target.name,
        });
    };
    const handleNextStepClick = () => props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "tradeInCar",
        name: "hasProvidedTradeInInfo",
        value: true,
    }, props.onProceedToNextStep);
    const handleSkipClick = () => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "tradeInCar",
            name: "hasProvidedTradeInInfo",
            value: false,
        }, () => {
            props.onIncompleteUserEvent(UserEvent.TRADE_IN_SKIPPED);
            props.onProceedToNextStep();
        });
    };
    const hasErrorRegistrationNumber = props.data.interact.tradeInCar.registrationNumber &&
        !validateRegistrationNumber(props.data.tradeInCar.registrationNumber);
    const hasErrorMilage = props.data.interact.tradeInCar.milage &&
        !validateMilage(props.data.tradeInCar.milage);
    const onKeyPress = (e) => handleEnterPress(e, props.onProceedToNextStep);
    const isValid = validateMilage(props.data.tradeInCar.milage) &&
        validateRegistrationNumber(props.data.tradeInCar.registrationNumber);
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Inbytesbil"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "Ange registreringsnumret och aktuellt miltal f\u00F6r din inbytesbil s\u00E5 f\u00E5r du ett uppskattat ink\u00F6pspris av oss."))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-form": "" },
                React.createElement("div", { className: "form-group-row" },
                    React.createElement("div", { className: `form-group is-half ${hasErrorRegistrationNumber ? " has-error" : ""}` },
                        React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "exchange-input-regnr" }, "Registreringsnummer"),
                        React.createElement("div", { "data-ecom-inputtext": "" },
                            React.createElement("input", { type: "text", id: "exchange-input-regnr", name: "registrationNumber", placeholder: "Registreringsnummer", value: props.data.tradeInCar.registrationNumber, onChange: handleInputChange, onBlur: handleBlur })),
                        React.createElement("div", { className: "form-alert" }, "Ett giltigt registreringsnummer beh\u00F6ver anges")),
                    React.createElement("div", { className: `form-group is-half ${hasErrorMilage ? " has-error" : ""}` },
                        React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "exchange-input-mileage" }, "Miltal (mil)"),
                        React.createElement("div", { "data-ecom-inputtext": "" },
                            React.createElement("input", { type: "text", id: "exchange-input-mileage", name: "milage", placeholder: "Miltal", value: props.data.tradeInCar.milage, onChange: handleInputChange, onBlur: handleBlur, onKeyPress: onKeyPress })),
                        React.createElement("div", { className: "form-alert" }, "Mellan 0 och 80 000 mil"))),
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "exchange-input-description" }, "Beskrivning (valfritt)"),
                    React.createElement("div", { "data-ecom-inputtext": "" },
                        React.createElement("textarea", { id: "exchange-input-description", name: "description", placeholder: "\u00C4r det n\u00E5got mer om din inbytesbil du vill ber\u00E4tta f\u00F6r bilhandlaren, n\u00E5got som kan p\u00E5verka v\u00E4rdet s\u00E5som servicehistorik, extrautrustning, vinterd\u00E4ck?", value: props.data.tradeInCar.description, onChange: handleInputChange, style: { height: "100px" } }))))),
        !props.isWaitingForResponse && (React.createElement(React.Fragment, null,
            React.createElement("section", { className: "page-section" },
                React.createElement("div", { className: "repeat-m" },
                    React.createElement("button", { "data-ecom-button": "full-width", onClick: handleNextStepClick, disabled: !isValid }, "G\u00E5 vidare")),
                React.createElement("div", { className: "repeat-m" },
                    React.createElement("button", { "data-ecom-button": "full-width light", onClick: handleSkipClick }, "G\u00E5 vidare utan inbytesbil"))))),
        props.isWaitingForResponse && (React.createElement("section", { className: "page-section" },
            React.createElement(Spinner, null)))));
};
